module.exports = __webpack_public_path__ + "img/stomp.6ea8b379.jpg";